import {ApiDocs} from './api-docs';

export default {
    component: ApiDocs
};
